import { Box } from "@mui/material"
import type { ReactElement } from "react"
import React from "react"
import { useFormContext } from "react-hook-form"

import type { ProductClassificationFormValues } from "./classSchema"

import ReadOnlyField from "@/components/FormReadOnlyValue/FormReadOnlyValue"
import ClassificationInput from "@/screens/ManageProducts/components/ProductClasses/components/form/ClassificationInput"
import ProductManagerSelect from "@/screens/ManageProducts/components/ProductClasses/components/form/ProductManagerSelect"
import type { EditDialogMode } from "@/screens/ManageProducts/components/ProductClasses/types"
import { EditDialogModes } from "@/screens/ManageProducts/components/ProductClasses/types"

interface ProductClassFormProps {
  onSubmit: () => void
  mode: EditDialogMode
}

const EditProductClassForm = ({ onSubmit, mode }: ProductClassFormProps): ReactElement => {
  const { watch } = useFormContext<ProductClassificationFormValues>()

  const categoryIds = watch("category.id") ? [watch("category.id")] : []
  const categoryName = watch("category.label") || "-"
  const classificationName = watch("name") || "-"
  const productManager = watch("productManager.label") || "-"

  const canChangeProductManager = mode === EditDialogModes.EditProductManager
  const canChangeClassificationName = mode === EditDialogModes.EditName

  return (
    <form onSubmit={onSubmit} className='space-y-8'>
      <Box className='flex flex-col'>
        <ReadOnlyField label='Category' value={categoryName} />

        {!canChangeClassificationName && <ReadOnlyField label='Class Name' value={classificationName} />}
        {!canChangeProductManager && <ReadOnlyField label='Product Manager' value={productManager} />}
      </Box>
      {canChangeClassificationName && <ClassificationInput categoryIds={categoryIds} />}
      {canChangeProductManager && <ProductManagerSelect />}
    </form>
  )
}

export default EditProductClassForm
